<template>
  
    <!-- <header id="header"> -->
  <header id="header" class="underborder">
    <div class="container clearfix">            
          <div class="f-left">
            <!--  onclick="window.history.back();" -->
              <button v-if="(showBack)" type="button" class="btn-back" @click="onBackPressed"><span class="blind">이전 페이지로</span></button>                                
              <img v-if="(showLeftMenu && loginState)" src="@/assets/img/ico-menu.jpg" alt="menu" class="btn-menu" @click="onMenuItemSelected('OPEN_MENU')">                                
          </div>
          <h1 class="f-center" v-if="(showLogo)">
            <router-link to="/">
                <img src="@/assets/img/logo-gongcha.jpg" alt="Gong cha">
            </router-link>
          </h1>
          <h1 v-else-if="(showTitle)">
            {{title}}
          </h1>

          <div class="f-right" >
              <div class="box-alarm" v-if="(showAlarm && loginState)">
                  <!-- 알림이 있는 경우 -->
                  <a  @click="onMenuItemSelected('ALARM')">
                      <!-- <img src="@/assets/img/ico-alarm-on.png" alt="알림" class="alarm-on" > -->
                      <div class="alarm-on" />
                  </a>
                  <!--// 알림이 있는 경우 -->
              </div>

              <router-link to="/" v-if="(showHome)">
                  <button type="button" class="btn-home"><span class="blind">공차 메인으로 이동</span></button>
              </router-link>

              <a class="btn-cart" @click="onMenuItemSelected('CART')" v-if="(showCart)">                
                  <span class="cnt-cart" v-if="(cartCount > 0)">{{cartCount}}</span>                
              </a>

              <button type="button" class="btn-close" v-if="(showClose)" @click="onClose">
                    <span class="blind">닫기</span>
                </button>
          </div>
      </div>    
    <div class="dimmed clickable-dimmed dp-none" @click="onDimmedClicked"></div>
    <div class="dimmed non-clickable-dimmed dp-none"></div>
    <menu-left/>
  </header>
  
</template>

<script>
import {LoginConfig} from '@/store/Constraints';
import MenuTop from '@/components/common/menuheader/MenuTop.vue';
import MenuLeft from '@/components/common/menuheader/MenuLeft.vue';
import {MenuBarItem,OrderType} from "@/components/AppConstants";
import {OrderConfig,GiftShopConfig} from '@/store/Constraints';

export default {
  
  components: {MenuTop, MenuLeft},
  props: {
    // options: {
    //   type: Object,
    //   default () {
    //     return {
    //       hasLabels: true,
    //       isHorizonal: false
    //     }
    //   }
    // }
    'title':'',
    'isModal': {
        type: Boolean,
        default: false
      },
    'showTitle': {
        type: Boolean,
        default: false
      },
    'showLogo': {
        type: Boolean,
        default: false
      },
    'showAlarm': {
        type: Boolean,
        default: false
      },
    'showBack': {
        type: Boolean,
        default: false
      },
    'showLeftMenu': {
        type: Boolean,
        default: true
      },
    'showHome': {
        type: Boolean,
        default: false
      },
    'showCart': {
        type: Boolean,
        default: false
      },
    'cart':{
      type:Object,
      default:function(){
        return {
          'url':'/order/cart',          
          'count':0
        }
      }
    },
    'showClose': {
      type: Boolean,
      default: false
    },
    'showLogo': {
      type: Boolean,
      default: false
    },
    'orderType':{
      type:String,
      default:'ORD'
    }
  },
  computed: {
      
      mainInfo:function(){
          return this.$store.getters[LoginConfig.MAIN_DATA]
      },
      cartCount(){
        switch(this.orderType){
          case OrderType.MemberShip:
            return this.$store.getters[OrderConfig.CART_COUNT];
          case OrderType.Delivery:
            return this.$store.getters[OrderConfig.CART_COUNT];
          case OrderType.Table:
            return this.$store.getters[OrderConfig.CART_COUNT];
          case OrderType.EGift:
            return this.$store.getters[GiftShopConfig.CART_COUNT];
        }
      }

  },
  mounted() {
    // console.log(`CommonHeader.mounted -> cart : ${JSON.stringify(this.cart)}`);
  },
  methods: {
    onBackPressed:function(e){
      console.log(`CommonHeader.methods.onBackPressed isModal:${this.isModal}`);
      // this.isModal?this.$emit('onBackPressed',e):window.history.back();     
      this.isModal?this.$emit('onBackPressed',e):this.$router.go(-1); 
    },
    onMenuItemSelected:function(menu){
      console.log('CommonHeader.methods.onMenuItemSelected=>',menu);
      // if(menu == MenuBarItem.OpenMenu.name){
      //   this.showMenu();
      //   return;
      // }
      
      switch(menu){
        case MenuBarItem.OpenMenu.name:
          this.openMenu();
          break;
        case MenuBarItem.Alarm.name:
          this.checkLoginAndPush('notice',MenuBarItem.Alarm)
          break;
        case MenuBarItem.Barcode.name:
          this.checkLoginAndPopup('order',MenuBarItem.Barcode)
          break;
        case MenuBarItem.Cart.name:
          this.checkLoginAndPush(this.cart.url,MenuBarItem.Cart)
          break;
        }
    },
    // onLeftMenuSelectedEvent:function(menu){
    //   console.log('MenuHeader.methods.onLeftMenuSelectedEvent=>',menu);
    //   this.$emit('onLeftMenuSelectedEvent',menu);      
    // },
    checkLoginAndPush(route,Menu){
      console.log('CommonHeader.methods.checkLoginAndPush - ',route,Menu);
      if(Menu.need_login && this.loginState != true){
        this.openPopAlert('login-alert') 
        
        return;   
      }
      // this.hideMenu();
      this.$router.push(route)      
    },
    checkLoginAndPopup(popup,Menu){
      console.log('CommonHeader.methods.checkLoginAndPopup - ',popup,Menu);
      if(Menu.need_login && this.loginState != true){
        this.openPopAlert('login-alert')    
        
        return;   
      }
      // this.hideMenu();
      this.openPop(popup);
    },
    
    openMenu:function(){
        this.showMenu();
    },
    onClose:function(){
      this.$emit('onClose')
    },
    onDimmedClicked() {
      this.hideMenu();
      this.$emit('hiddenMenu');
      this.closeAlertConfirm();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/CommonHeader.vue